interface ScrollOptions {
  behavior: ScrollBehavior;
  offset: number;
  elementSelector: string;
}

const DEFAULT_FIELD_ID_SELECTOR = '[data-field-id="{id}"]';

export const scrollToError = (errorFieldIds: string[], options: Partial<ScrollOptions> = {}): void => {
  const scrollOptions: ScrollOptions = {
    behavior: 'smooth',
    offset: 100,
    elementSelector: DEFAULT_FIELD_ID_SELECTOR,
    ...options,
  };

  const errorElements = getElementsByErrorIds(errorFieldIds, scrollOptions);
  if (errorElements.length === 0) return;

  const sortedElements = sortElementsByTop(errorElements);

  scrollToElement(sortedElements[0], scrollOptions);
};

export const getElementsByErrorIds = (errorFieldIds: string[], scrollOptions: ScrollOptions) => {
  return errorFieldIds
    .map((fieldId) => {
      const selector = scrollOptions.elementSelector.replace('{id}', fieldId);
      return document.querySelector(selector);
    })
    .filter((element): element is HTMLElement => element !== null && element instanceof HTMLElement);
};

export const sortElementsByTop = (elements: HTMLElement[]) => elements.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

export const scrollToElement = (element: HTMLElement, scrollOptions: ScrollOptions) => {
  const elementTop = element.getBoundingClientRect().top + window.scrollY - scrollOptions.offset;

  window.scrollTo({
    top: elementTop,
    behavior: scrollOptions.behavior,
  });
};
